import { useEffect, useRef } from "react";
import axios from "axios";
import { App as AntApp } from "antd";
import { getApiErrorMessage, shouldNotifyGlobalApiError } from "../utils/apiErrorMessage";

const DEDUPE_MS = 2500;

/**
 * Central axios error toast for Admin API failures (4xx/5xx, network).
 * Mount inside <AntApp>. Opt out per request with `skipGlobalErrorToast: true` on axios config.
 */
export default function ApiErrorNotifier() {
  const { message } = AntApp.useApp();
  const lastToastRef = useRef({ key: "", at: 0 });

  useEffect(() => {
    const interceptorId = axios.interceptors.response.use(
      (response) => response,
      (error) => {
        if (shouldNotifyGlobalApiError(error)) {
          const text = getApiErrorMessage(error);
          const status = error?.response?.status ?? "network";
          const key = `${status}:${text}`;
          const now = Date.now();
          const last = lastToastRef.current;
          if (last.key !== key || now - last.at > DEDUPE_MS) {
            lastToastRef.current = { key, at: now };
            message.error(text);
          }
        }
        return Promise.reject(error);
      }
    );

    return () => axios.interceptors.response.eject(interceptorId);
  }, [message]);

  return null;
}
